module.exports = __webpack_public_path__ + "img/icon-chat-light.23143982.svg";